module.exports = __webpack_public_path__ + "static/media/matt-left.9a636c8e.PNG";